import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { getDataError, getDataSuccess, updateDataError, updateDataSuccess } from './actions'
import { GET_DATA_ASYNC, UPDATE_DATA_ASYNC } from './constants'

const getDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      GET_DATA_ASYNC.INITIATE,
      UPDATE_DATA_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.microsoftQuarantine)
      return true
    }),
    mergeMap(() =>
      api.settings.getMicrosoftQuarantine(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getDataSuccess({ data: response })),
        catchError((error) => of(epicsErrorHandler(getDataError, error))),
        takeUntil(action$.pipe(ofType(GET_DATA_ASYNC.CANCEL)))
      )
    )
  )

const updateDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_DATA_ASYNC.INITIATE),
    mergeMap((action) => {
      const state = state$.value
      const selectedCompany = selectCompanyFilter(state)?.value

      return api.settings
        .updateMicrosoftQuarantine(
          selectedCompany,
          action.payload.microsoftDetectionsEnabled,
          action.payload.microsoftReleaseQuarantinedEmailEnabled
        )
        .pipe(
          mergeMap((response) => of(updateDataSuccess(response))),
          catchError((error) => of(epicsErrorHandler(updateDataError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_DATA_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(getDataEpic, updateDataEpic)
